import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Container, Button } from '@mui/material';

import { ITransporterDetails } from "../../../types/transporter";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";

import TransporterDetailsForm from "../../forms/transporterDetailsForm";
import { Icons } from "../../icons";

const TransporterAdd = () => {
	const userContext = useUserContext();
	const [formFields, setFormFields] = useState<ITransporterDetails>({
		name: "",
		dotNumber: "",
		statusId: "",
	});

	const reset = async () => {
		setFormFields({
			name: "",
			dotNumber: "",
			statusId: "",
		});
	}

	return (
		<div className="hwi-transporter-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageTransporters}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/transporter">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Transporter
						</div>
					</section>
					<section className="management-page-form">
						<TransporterDetailsForm action="add" details={formFields} reloadData={reset} ></TransporterDetailsForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default TransporterAdd;